<template>
  <section>
    <div v-if="title" class="sm:flex flex-row items-center justify-between leading-none mb-4 sm:mb-6">
      <h2 class="flex-auto text-xl sm:text-2xl lg:text-3xl font-semibold text-app-primary-1-red--fire-brick" :class="{ 'mb-2 sm:mb-0': buttonUrl }">{{ title }}</h2>
      <MoleculeButton v-if="buttonUrl" :url="buttonUrl" :enable-icon-left="false" size="small" class="md:hidden">
        {{ buttonTitle }}
      </MoleculeButton>
      <MoleculeButton v-if="buttonUrl" :url="buttonUrl" :enable-icon-left="false" size="large" class="hidden md:block">
        {{ buttonTitle }}
      </MoleculeButton>
    </div>
    <div :class="{ 'pb-4 sm:pb-6 border-b border-app-primary-grey--black-squeeze': hasBorder }">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: false, default: undefined },
  buttonTitle: { type: String, required: false, default: undefined },
  buttonUrl: { type: String, required: false, default: undefined },
  hasBorder: { type: Boolean, required: false, default: true },
})
</script>
